import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const PADDING = primitiveTokens.sizing["0.25x"];

// Two equal columns, so the thumb's half fits the wider label.
export const segmentedSwitchRoot = style({
  position: "relative",
  display: "inline-grid",
  gridTemplateColumns: "1fr 1fr",
  padding: PADDING,
  border: `${primitiveTokens.borderWidth.default} solid`,
  borderColor: semanticThemeTokens.toggleGroup.item.borderColor,
  borderRadius: primitiveTokens.radii.md
});

export const segmentedSwitchThumb = style({
  position: "absolute",
  top: PADDING,
  bottom: PADDING,
  left: PADDING,
  width: `calc(50% - ${PADDING})`,
  borderRadius: primitiveTokens.radii.sm,
  // The toggle group's selected item, so both controls mark a pick alike.
  backgroundColor:
    semanticThemeTokens.toggleGroup.item.selected.backgroundColor,
  transition: "transform 200ms",
  willChange: "transform",
  selectors: {
    "&[data-side='right']": { transform: "translateX(100%)" }
  }
});

// Over the thumb, which slides beneath.
export const segmentedSwitchItem = style({
  position: "relative",
  padding: `2px ${primitiveTokens.sizing["2x"]}`,
  border: "none",
  borderRadius: primitiveTokens.radii.sm,
  background: "transparent",
  color: "inherit",
  cursor: "pointer",
  fontSize: primitiveTokens.type.xs,
  textAlign: "center",
  whiteSpace: "nowrap",
  transition: "color 200ms",
  selectors: {
    "&:focus-visible": {
      boxShadow: semanticThemeTokens.toggleGroup.item.focus.boxShadow,
      outline: semanticThemeTokens.toggleGroup.item.focus.outline
    },
    "&[data-state='on']": {
      color: semanticThemeTokens.toggleGroup.item.selected.textColor
    },
    "&[data-disabled]": { cursor: "default", opacity: 0.5 }
  }
});
